import { accessRouteChain } from './access-route-chain.js';
import type { AccessRoute } from './route-access.js';

export function routeRequiresBrandMembership(route: AccessRoute): boolean {
  return accessRouteChain(route).some((entry) => entry.requiresBrandMembership === true);
}
